var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user"},[_c('div',{staticClass:"photo"},[_c('img',{attrs:{"src":_vm.getLogoURL,"alt":"user avatar"}})]),_c('div',{staticClass:"info"},[_c('a',{staticStyle:{"color":"white"}},[_c('span',[_vm._v(" "+_vm._s(_vm.getFullName)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }